<template>
         
    <div class="container">
    
    <div v-if="!presentation" class="form">
         <ColorSelector  
            @set_global_id = set_global_id
            :fly_position="{x:6, y:6, z:6}"
            :sel_id="'hand_side'" 
            :global_id="global_id"
            :type="'text'" 
            :title = "$t('message.injury_side')" 
            :items = "hand_side_array" 
            v-model="hand_side">
        </ColorSelector> 
        <ColorSelector 
            :fly_position="{x:0.73, y:4.2, z:0.02}"
            @set_global_id = set_global_id
            :sel_id="'fingertip'"
            :global_id="global_id"
            :type="'color'" 
            :title = "$t('message.fingertip_color')" 
            :items = "fingertip_color_array" 
            v-model="fingertip_color">
        </ColorSelector>    
        <ColorSelector  
           
            @set_global_id = set_global_id
            :fly_position="{x:4.85, y:5.91, z:3.61}"
            :sel_id="'wrist_color'"
            :global_id="global_id"
            :type="'color'" 
            :title = "$t('message.wrist_color')"
            :items = "wrist_color_array" 
            v-model="wrist_color">

        </ColorSelector>
        
        <ColorSelector
            @set_global_id = set_global_id
            :fly_position="{x:-1.68, y:5.79, z:1.53}"
            :sel_id="'finger_color'" 
            :global_id="global_id"
            :type="'color'" 
            :title = "$t('message.finger_color')"  
            :items = "finger_color_array" 
            v-model="finger_color">

        </ColorSelector>
        <ColorSelector
            @set_global_id = set_global_id
            :fly_position="{x:-3.62, y:4.12, z:2.18}"
            :sel_id="'forearm_color'"
            :global_id="global_id"
            :type="'color'" 
            :title = "$t('message.forearm_color')" 
            :items = "forearm_color_array" 
            v-model="forearm_color">

        </ColorSelector>
        
        
        <!--div class=" mt-3 col-12">
            <input class="btn btn-success float-right" type="button" :value="$t('message.form_a_request')" @click="$modal.show('contact')">
        </div-->     

    </div>   
    
    <div id="constructor_container" class="object">
        <div class="button button-left" @click="list('left')"><font-awesome-icon :icon="['fas', 'angle-left']"/></div>
        <div class="button button-right" @click="list('right')"><font-awesome-icon :icon="['fas', 'angle-right']"/></div>
         <radial-progress-bar style="position: absolute; top: 50%; left: 50%; margin-right: -50%; transform: translate(-50%, -50%);" 
            v-if = "loading"
            :diameter="90"
            :completed-steps="completedSteps"
            :total-steps="totalSteps">
            {{ completedSteps }}%
        </radial-progress-bar>
    </div>

    <modal  height="auto" name="contact" resize="tue" :adaptive="true">
            <slot name="top-right">
                <button @click="$modal.hide('contact')">X</button>
            </slot>
        <Contacts @final-send = "send" :send_errors="send_errors"></Contacts>
    </modal>   
    <modal  height="auto" name="thanks" :adaptive="true">
        <h4 class="alert-heading"> {{$t('message.success_message_1')}}</h4>
  <p>{{$t('message.success_message_2')}}</p>
  <hr>
        <input class="btn btn-success btn-block" type="button" value="Закрыть" @click.prevent="$modal.hide('thanks')">
    </modal>        
</div>
</template>
<script>
import colors_array from '@/components/colors.js'   
import * as THREE from 'three'
import GLTFLoader from 'three-gltf-loader';
import OrbitControls from 'threejs-ext/src/controls/OrbitControls';
import ColorSelector from 'vue-hotenot-selector';


import TWEEN from 'tween.js'
import RadialProgressBar from 'vue-radial-progress'
//import { EffectPass,  RenderPass, ShaderPass } from "postprocessing";

export default {
  name: 'ThreeTest',
  data() {
    return {
      presentation:false,
      presentation_flys_index:0,
      presentation_flys:[
          {fly_position:{x:6, y:6, z:6}},
          {fly_position:{x:0.73, y:4.2, z:0.02}},
          {fly_position:{x:-1.68, y:5.79, z:1.53}},
          {fly_position:{x:-2.68, y:-7.55, z:0.66}},
          {fly_position:{x:-1.68, y:5.79, z:1.53}},
          {fly_position:{x:-3.62, y:4.12, z:2.18}},
          {fly_position:{x:-4.56, y:-0.27, z:0.05}}
      ],  
        
      totalSteps:100,
      completedSteps:5,
      send_errors:'rrrrrr',
      global_id:null,
      
      loading:true,  
      container:null,  
      main_container:null, 
      renderer: null,
      scene: null,
      camera: null,
      light:null,
      light2:null,
       light3:null,
        light4:null,
      conrols:null,  
      
      type:'6402',// вид протеза ид битрикса
      lid_typ:'6098',//тип лида
      wrist_color:'corporeal',
      wrist_color_array:colors_array,
      

      hand_side:'1714',
      hand_side_array:[],
      
      fingertip_color:'corporeal',
      fingertip_color_array:colors_array,
      
      
      finger_color:'corporeal',
      finger_color_array:colors_array,
      forearm_color:'corporeal',
      forearm_color_array:colors_array,
      
    }
    
  },
  
  components: {
    RadialProgressBar,
    ColorSelector,
  },
    watch:{
        wrist_color: function (val) {
            this.scene.children[2].getObjectByName('hand').material.color.set(this.find_data(this.wrist_color_array, val).data);   
            this.scene.children[2].getObjectByName('picture_hand').material.color.set(this.find_data(this.wrist_color_array, val).data);
        
        }, 
        fingertip_color: function (val) {
            this.scene.children[2].getObjectByName('fn_silicon').material.color.set(this.find_data(this.fingertip_color_array, val).data); 
             this.scene.children[2].getObjectByName('bf_silicon').material.color.set(this.find_data(this.fingertip_color_array, val).data); 
              this.scene.children[2].getObjectByName('touch').material.color.set(this.find_data(this.fingertip_color_array, val).data);   
        },
        finger_color: function (val) {
            this.scene.children[2].getObjectByName('finger').material.color.set(this.find_data(this.finger_color_array, val).data);   
        },
        forearm_color: function (val) {
            this.scene.children[2].getObjectByName('forearm').material.color.set(this.find_data(this.forearm_color_array, val).data);   
        },
        
        hand_side:function(val){
            if(val !=='6088'){  
                this.scene.children[2].traverse( function ( child ) {
                    if ( child.isMesh ) {
                        child.applyMatrix(new THREE.Matrix4().makeScale(-1, 1, 1))
                    }  
                })
            }
        },
        presentation_flys_index:function(id){
           this.set_global_id(false, this.presentation_flys[id].fly_position)
           
        }  
    },
    
  methods: { 
    init: function() {
        

        this.main_container = document.getElementById('constructor_container')
        this.scene = new THREE.Scene()
        const loader = new GLTFLoader();
        loader.setCrossOrigin( 'Anonymous');
        
        this.renderer = new THREE.WebGLRenderer({antialias:true, alpha:true ,preserveDrawingBuffer:true})
        this.renderer.setSize(this.main_container.offsetWidth, this.main_container.offsetHeight)
        this.renderer.setPixelRatio( window.devicePixelRatio*1.7 );
        this.renderer.setClearColor( 0x000000, 0 );
        
        
        
        this.main_container.appendChild(this.renderer.domElement)
        const url =  "forearm_model/indy_new.gltf"
        loader.load(url, 
            (gltf)=> {
                this.loading = false;
                const root = gltf.scene;
                this.scene.add(root);
                this.preset();

            },
            (xhr)=> {
                this.completedSteps = Math.round(xhr.loaded / xhr.total * 100);
            },
        );
        this.scene.scale = new THREE.Vector3(1,1,1)
        this.scene.position = new THREE.Vector3(0,0,0)
       
        
        this.camera = new THREE.PerspectiveCamera(17, this.main_container.offsetWidth / this.main_container.offsetHeight, 1, 10000 );
        this.camera.position.set( 6, 6, 6 );
        this.camera.lookAt(this.scene.position);
        this.camera.updateProjectionMatrix();

        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        //this.controls.enableZoom = false;
        this.controls.maxPolarAngle = Math.PI / 1;
        
        this.controls.update();
        this.light = new THREE.PointLight(0xffffff,1);
        this.light.position.set(2500, 2500, 2500);
        this.light2 = new THREE.PointLight(0xffffff,1);
        this.light2.position.set(-2500, -2500, -2500);
        this.light3 = new THREE.DirectionalLight(0xffffff,1);
        this.light3.position.set(0, 0, 0);
        this.scene.add( this.light );
        this.scene.add( this.light2 );
        //this.scene.add( this.light3 );
       
        
        
        
        
    },
    
    
    resize: function(){
    this.camera.aspect = this.main_container.offsetWidth / this.main_container.offsetHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize( this.main_container.offsetWidth, this.main_container.offsetHeight );
    },
    
    animate: function() {
        this.camera.updateProjectionMatrix();
        requestAnimationFrame(this.animate);
        TWEEN.update();
        this.render();
    },
    
    render:function(){
        this.camera_x=this.camera.position.x
        this.camera_y=this.camera.position.y
        this.camera_z=this.camera.position.z
        this.controls.update();
        this.scene.rotation.y += 0.01;
        this.renderer.render(this.scene, this.camera);
    },
    
    
    preset: function() {
        this.scene.children[2].getObjectByName('forearm').material.color.set(this.find_data(this.forearm_color_array,this.forearm_color).data);
        this.scene.children[2].getObjectByName('hand').material.color.set(this.find_data(this.wrist_color_array, this.wrist_color).data);
        this.scene.children[2].getObjectByName('picture_hand').material.color.set(this.find_data(this.wrist_color_array, this.wrist_color).data);
        
        this.scene.children[2].getObjectByName('fn_silicon').material.color.set(this.find_data(this.fingertip_color_array,this.fingertip_color).data);
        this.scene.children[2].getObjectByName('bf_silicon').material.color.set(this.find_data(this.fingertip_color_array,this.fingertip_color).data);
       this.scene.children[2].getObjectByName('touch').material.color.set(this.find_data(this.fingertip_color_array,this.fingertip_color).data);
        this.scene.children[2].getObjectByName('forearm').material.color.set(this.find_data(this.forearm_color_array,this.forearm_color).data);
        this.scene.children[2].getObjectByName('finger').material.color.set(this.find_data(this.finger_color_array,this.finger_color).data);   
    },
    
    find_data: function(list, value){
        for(let key in list){
              if(list[key].value == value){
                  return list[key]
              } 
           } 
    },
    
    
    set_global_id:function(id, fly_position){
              this.global_id=id  
              this.fly(fly_position)
    },
    
    fly: function(fly_position){
        if (this.inverse){
            fly_position.x = -fly_position.x
        }
        let self = this
        this.controls.enabled = false;
        let duration = 2000;
        let position = new THREE.Vector3().copy(this.camera.position);
        let targetPosition = new THREE.Vector3(fly_position.x, fly_position.y, fly_position.z);
        new TWEEN.Tween(position)
            .to(targetPosition, duration)
            .easing( TWEEN.Easing.Back.InOut )
            .onUpdate(function () {
                self.camera.position.copy(position);
                self.camera.lookAt( self.controls.target );
            })
            .onComplete(function () {
                self.camera.position.copy( targetPosition );
                self.camera.lookAt( self.controls.target );
                self.controls.enabled = true;
            })
            .start();
    },
    
    list: function(direct){
        let fl_index = this.presentation_flys_index;
        if(direct=='left'){
            fl_index --
        }else{
            fl_index ++
        }
        
        if(fl_index < 0){
           this.presentation_flys_index = this.presentation_flys.length-1 
        }else if(fl_index > this.presentation_flys.length-1){
            this.presentation_flys_index = 0
        }else{
           this.presentation_flys_index = fl_index 
        }
        
    },
    
    
    url_param_search: function(key){
        let s = window.location.search;
        s = s.match(new RegExp(key + '=([^&=]+)'));
        return s ? s[1] : false;
    },
    
    setValues:  function(){
        this.hand_side_array = [
          {id:'hand_side_l', value:'1712', data: this.$t('message.left')},
          {id:'hand_side_2', value:'1714', data: this.$t('message.right')},
          {id:'hand_side_3', value:'6088', data: this.$t('message.two')}   
        ]
    },
    
    setParams: function(){
        if(this.url_param_search('mode') && this.url_param_search('mode') == 'presentation'){
            this.presentation = true
        }
        if(this.url_param_search('lang')){
            if(this.url_param_search('lang')=='en'){
                this.$i18n.locale = 'en'
            }else{
               this.$i18n.locale = 'ru'  
            }
        }else{
             this.$i18n.locale = 'ru'
        }
        if(this.url_param_search('wrist_color')){this.wrist_color = this.url_param_search('wrist_color')}
        if(this.url_param_search('fingertip_color')){this.fingertip_color = this.url_param_search('fingertip_color')}
        if(this.url_param_search('finger_color')) {this.finger_color = this.url_param_search('finger_color')}
        if(this.url_param_search('forearm_color')) {this.forearm_color =  this.url_param_search('forearm_color')}
    }
    
    
    
  },
  
  created() {
        window.addEventListener("resize", this.resize);
    },
  destroyed() {
        window.removeEventListener("resize", this.resize);
    }, 
  
  mounted() {  
    this.setParams() 
    this.setValues()
    this.init()
    this.animate()

  },
  
}
</script>
<style>
body{
    color:#696969 !important;
    font-size: 1em !important;
}
.container {
    display:flex;
    flex-wrap: wrap;
    justify-content: space-around;

}

@media (max-width: 980px)
{
    .object {
        width: 100% !important;
        height: 100%;
        
    }
    .form {
        width: 100% !important;
    }
}

.object {
    position: relative; 
    display: flex;
    align-items: center;
    height: 90vh;
    width: 70%;

}

.form {
    box-sizing: border-box;
    display: block;
    width: 30%;
    height: 100hv;
    top: 0px;
    left: 0px;
    min-width: 10%;
    font-size: 16px;
    user-select: none;
    overflow: hidden;
    margin-bottom: 10px;

}

.submit-button:hover {
    background-color: white; /* Green */
    color: #5CB85C;
     border: 1px solid #5CB85C;
   
}
.v--modal-overlay .v--modal-box{
        padding: 20px;
}
.v--modal-overlay .v--modal-box button{
        position: absolute;
        top:0;
        right: 0;
        padding: 5px;
  
    color: #5CB85C;
    data: none;
    font-size: 16px;   
    border: none;
    cursor: pointer;
}
.mt-5{
        margin-top: 5px;
}
.button{
    cursor: pointer;
    color:white;
    text-align: center;
    font-size: 20px;
    line-height: 36px;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    background-color: rgba(98, 98, 98, 0.5);
}
.button-left{
    position: absolute;
    top:50%;
    left: 40px;
}
.button-right{
    position: absolute;
    top:50%;
    right: 40px;
}


</style>    

